var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[(!_vm.post._id)?_c('Loading'):_vm._e(),(_vm.post._id)?_c('div',{staticClass:"col-md-12"},[_c('onePost',{key:_vm.post._id,attrs:{"post":_vm.post}})],1):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }